import axios from "axios";

// La URL de la API se define por deploy context en Netlify (prod en Production,
// dev en Branch deploys/Deploy Previews) y en el .env local.
const baseUrl =
  process.env.NEXT_PUBLIC_BASE_API_URL ?? "https://api-dev.maratonelsalvador.com";
const loginUrl = `${baseUrl}/api/v1/athlete/login`;
const registerUrl = `${baseUrl}/api/v1/athlete/register`;
const profileUrl = `${baseUrl}/api/v1/athlete/profile`;
const logOutUrl = `${baseUrl}/api/v1/athlete/logout`;
const eventsUrl = `${baseUrl}/api/v1/athlete/events`;
const inscriptionsUrl = `${baseUrl}/api/v1/athlete/inscriptions`;
const forgotPassUrl = `${baseUrl}/api/v1/athlete/password/forgot`;
const resetPassUrl = `${baseUrl}/api/v1/athlete/password/reset`;

// ASSETS URLS
const countriesUrl = `${baseUrl}/api/v1/general/countries`;
const documentsUrl = `${baseUrl}/api/v1/general/document-types`;

// AXIOS INSTANCES CREATOR
export const createPublicAxios = (baseURL: string) => {
  return axios.create({
    baseURL,
  });
};

// AXIOS INSTANCES
export const loginAxios = createPublicAxios(loginUrl);
export const registerAxios = createPublicAxios(registerUrl);
export const countriesAxios = createPublicAxios(countriesUrl);
export const documentsAxios = createPublicAxios(documentsUrl);
export const profileAxios = createPublicAxios(profileUrl);
export const logOutAxios = createPublicAxios(logOutUrl);
export const eventsAxios = createPublicAxios(eventsUrl);
export const inscriptionsAxios = createPublicAxios(inscriptionsUrl);
export const forgotPassAxios = createPublicAxios(forgotPassUrl);
export const resetPassAxios = createPublicAxios(resetPassUrl);
